import * as React from 'react'

import { Box, Text as DSText } from '@factorialco/deprecated-design-system'
import { CycleInfoSalaryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type CycleInfoProps = Pick<CycleInfoSalaryFragment, 'countryLabel' | 'recurrence'>

function CycleInfo({ countryLabel, recurrence }: CycleInfoProps) {
  return (
    <Box
      paddingY="s16"
      paddingX="s24"
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs016',
      }}
    >
      <DSText.Normal weight="semibold" color="grey1000">
        {countryLabel} {recurrence} {i18n.t('contract_versions.cycleInfo.payrollCycleCopy')}
      </DSText.Normal>
    </Box>
  )
}

export { CycleInfo }
